// extracted by mini-css-extract-plugin
module.exports = {"price-date":"Price_price-date__3iSy1","price-value":"Price_price-value__EcTQP","current-price":"Price_current-price__3TwdP","new-price":"Price_new-price__17ALQ"};